type SwipeUnlockHighlightListener = () => void;

const listeners = new Set<SwipeUnlockHighlightListener>();

/** Subscribe to highlight requests when power is tapped on an actively enforcing rule. */
export function subscribeSwipeUnlockHighlight(listener: SwipeUnlockHighlightListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Briefly pulse the global swipe-to-unlock track so the user notices it. */
export function requestSwipeUnlockHighlight(): void {
  for (const listener of listeners) listener();
}
